import api from "kw/api";
import { quoteFields, riskProfileFields } from "kw/api/fragments";
import { reduceQuotes } from "../utils/utils";
import { useEffect, useState } from "react";
import { useGlobal } from "kanopi-components/useGlobal";

interface IUseRiskProfileArgs {
  riskProfileId: number;
}

/**
 * Fetch the risk profile from the server.
 */
export function useRiskProfile(args: IUseRiskProfileArgs) {
  const { riskProfileId } = args;
  const [data = {}, setData] = useGlobal("quoting");
  const [, setProduct] = useGlobal("product");
  const { riskProfile } = data;
  const [isLoading, setLoading] = useState(true);
  const combinedQuote = reduceQuotes(riskProfile?.quotes || []);

  async function fetch() {
    setLoading(true);
    try {
      const riskProfile = await queryRiskProfile(riskProfileId);
      setData({
        riskProfile: {
          ...riskProfile,
        },
      });
      setProduct({
        key: riskProfile?.enabledProducts?.[0]?.key,
      });
    } catch (exc) {
      setData({
        riskProfile: null,
      });
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetch();
  }, []);
  return { riskProfile, quote: combinedQuote, isLoading };
}

async function queryRiskProfile(riskProfileId) {
  const response = await api.query(getRiskProfileQuery(riskProfileId));
  return response.riskProfile;
}

function getRiskProfileQuery(riskProfileId) {
  return {
    riskProfile: [
      {
        id: riskProfileId,
      },
      {
        ...riskProfileFields,
        enabledCovers: {
          id: true,
          title: true,
          description: true,
          icon: true,
        },
        enabledLimitations: {
          id: true,
          key: true,
          description: true,
          text: true,
          kind: true,
        },
        quotes: {
          ...quoteFields,
        },
      },
    ],
  };
}
